import React from 'react';

const PrecioDobleCell = React.memo(({
  productoId,
  campoKey,
  rowIndex,
  porcentaje,
  precio,
  hidden,
  onPorcentajeChange,
  onPrecioChange,
  onKeyNavigation,
  onDragHandleMouseDown
}) => {
  if (hidden) return <td className="col-precio-doble" style={{ display: 'none' }} />;

  return (
    <td className="col-precio-doble">
      <div className="precio-doble-input">
        <div className="input-drag-wrapper">
          <input
            type="number"
            min="0"
            step="0.1"
            value={porcentaje}
            onChange={(e) => onPorcentajeChange(productoId, campoKey, e.target.value)}
            onKeyDown={(e) => onKeyNavigation(e, rowIndex, `${campoKey}_pct`)}
            onFocus={(e) => e.target.select()}
            className="input-porcentaje"
            placeholder="%"
            title="Porcentaje de ganancia"
            data-row={rowIndex}
            data-col={`${campoKey}_pct`}
            data-producto-id={productoId}
            data-field-type="porcentaje"
            data-campo={campoKey}
          />
          {onDragHandleMouseDown && (
            <div
              className="drag-fill-handle"
              onMouseDown={(e) => onDragHandleMouseDown(e, rowIndex, `${campoKey}_pct`, productoId)}
              title="Arrastrar para copiar porcentaje"
            />
          )}
        </div>
        <div className="input-drag-wrapper">
          <input
            type="number"
            min="0"
            step="0.01"
            value={precio}
            onChange={(e) => onPrecioChange(productoId, campoKey, e.target.value)}
            onKeyDown={(e) => onKeyNavigation(e, rowIndex, `${campoKey}_precio`)}
            onFocus={(e) => e.target.select()}
            className="input-precio"
            title="Precio final"
            data-row={rowIndex}
            data-col={`${campoKey}_precio`}
            data-producto-id={productoId}
            data-field-type="precio"
            data-campo={campoKey}
          />
          {onDragHandleMouseDown && (
            <div
              className="drag-fill-handle"
              onMouseDown={(e) => onDragHandleMouseDown(e, rowIndex, `${campoKey}_precio`, productoId)}
              title="Arrastrar para copiar precio"
            />
          )}
        </div>
      </div>
    </td>
  );
}, (prev, next) => {
  return prev.porcentaje === next.porcentaje
    && prev.precio === next.precio
    && prev.rowIndex === next.rowIndex
    && prev.hidden === next.hidden;
});

PrecioDobleCell.displayName = 'PrecioDobleCell';

export default PrecioDobleCell;
